<template>
  <div class="WeChatAuthorizat">
    <div class="WeChatAuthorizat-wrapper">
      <div class="WeChatAuthorizat-logo">
        <img src="/static/img/WeChatAuthorizat_logo.png" />
      </div>
      <div class="WeChatAuthorizat-item">
        <div class="WeChatAuthorizat-tabs">
          <span :class="{ active: WeChatType == WeChatTab.value }" @click="ChaneWeChatType(WeChatTab.value)" v-for="WeChatTab in WeChatTabs" :key="WeChatTab.value">{{ WeChatTab.label }}</span>
        </div>
        <div class="WeChatAuthorizat-card" v-if="WeChatType == 0">
          <div class="WeChatAuthorizat-user">
            <div>
              <input :placeholder="$t('system_user_modules_authorizat_qiyezhanghaoyouxiangshoujihao')" v-model="value.UserAct" />
            </div>
            <div>
              <img style="width:0.532rem;vertical-align:middle" src="/static/img/WeChatAuthorizat_user.png" />
            </div>
          </div>
          <div class="border_bottom"></div>
          <div class="WeChatAuthorizat-user">
            <div style="margin-right: 1.330rem;">
              <input id="loginPwd" v-model="value.UserPwd" :type="pwdFlag ? 'text' : 'password'" :placeholder="$t('placeholders.Password')" />
            </div>
            <div>
              <img style="width:0.532rem;vertical-align:middle" src="/static/img/WeChatAuthorizat_pwd.png" />
            </div>
            <div>
              <label @click="pwdFlag = !pwdFlag">
                <img v-if="pwdFlag" src="/static/img/view.png" style="height:0.399rem" />
                <img v-if="!pwdFlag" src="/static/img/viewno.png" style="height:0.399rem" />
              </label>
            </div>
          </div>
        </div>
        <div class="WeChatAuthorizat-card" v-if="WeChatType == 1">
          <div class="WeChatAuthorizat-user">
            <div>
              <input :placeholder="$t('system_user_modules_authorizat_qingshuruzhanghu')" v-model="value.UserAct" />
            </div>
            <div>
              <img style="width:0.532rem;vertical-align:middle" src="/static/img/WeChatAuthorizat_user.png" />
            </div>
          </div>
          <div class="border_bottom"></div>
          <div class="WeChatAuthorizat-DynamicCode">
            <div>
              <input :placeholder="$t('system_user_modules_authorizat_buqufendaxiaoxie')" v-model="value.ValidCode" />
            </div>
            <div>
              <img style="width:0.532rem;vertical-align:middle" src="/static/img/WeChatAuthorizat_DynamicCode.png" />
            </div>
            <div>
              <img :src="checkImageUrl" style="height:0.798rem;vertical-align: middle;" @click="ReloadImage" />
            </div>
          </div>
          <div class="border_bottom"></div>
          <div class="WeChatAuthorizat-code">
            <div>
              <input :placeholder="$t('system_user_modules_authorizat_qingshuruyanzhengma')" v-model="value.UserCode" />
            </div>
            <div>
              <img style="width:0.532rem;vertical-align:middle" src="/static/img/WeChatAuthorizat_code.png" />
            </div>
            <div>
              <div class="sendCode" @click="sendCode">{{ $t(textCode) }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="WeChatAuthorizat-btn" @click="login">{{ $t("system_user_modules_authorizat_lijibangding") }}</div>
      <div class="ordinary-tips">
        <span @click="ToRegister">{{ $t("system_user_modules_authorizat_lijizhuce") }}</span>
        <!-- <span @click="ToReset">{{ $t("system.ForgetPassword") }}</span> -->
      </div>
    </div>
  </div>
</template>
<style scoped>
  .ordinary-tips {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.425rem;
    padding-top: 0.798rem;
    color: #fff;
  }

  .WeChatAuthorizat {
    width: 100%;
    height: 100%;
    background-image: url("/static/img/WeChatAuthorizatBg.jpg");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .WeChatAuthorizat-tabs {
    background-color: #b3c6db;
    height: 1rem;
    line-height: 1rem;
    overflow: hidden;
    border-top-left-radius: 0.106rem;
    border-top-right-radius: 0.106rem;
  }

  .WeChatAuthorizat-tabs span {
    position: relative;
    display: inline-block;
    color: #014086;
    text-align: center;
    width: 50%;
    float: left;
    font-size: 0.35rem;
  }

  .WeChatAuthorizat-tabs span::before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: -1;
    height: 100%;
    background-color: #58a;
    transform: scaleY(1.1) perspective(1rem) rotateX(6deg);
    transform-origin: bottom right;
  }

  .WeChatAuthorizat-tabs .active {
    z-index: 1;
  }

  .WeChatAuthorizat-tabs span.active::before {
    background: #fff;
  }

  .WeChatAuthorizat-tabs span:first-child.active::before {
    transform-origin: bottom left;
  }

  .WeChatAuthorizat-user,
  .WeChatAuthorizat-DynamicCode,
  .WeChatAuthorizat-code {
    position: relative;
  }

  .WeChatAuthorizat-user > div {
    line-height: 1.596rem;
    height: 1.596rem;
  }

  .WeChatAuthorizat-user > div:first-child,
  .WeChatAuthorizat-DynamicCode > div:first-child,
  .WeChatAuthorizat-code > div:first-child {
    margin-left: 1.537rem;
    text-align: center;
    margin-right: 0.399rem;
  }

  .WeChatAuthorizat-user input,
  .WeChatAuthorizat-DynamicCode input,
  .WeChatAuthorizat-code input {
    width: 100%;
    border: 0;
    height: 100%;
  }

  .WeChatAuthorizat-user > div:nth-child(2),
  .WeChatAuthorizat-DynamicCode > div:nth-child(2),
  .WeChatAuthorizat-code > div:nth-child(2) {
    position: absolute;
    top: 0;
    left: 0;
    width: 1.537rem;
    text-align: center;
  }

  .WeChatAuthorizat-user > div:nth-child(3) {
    position: absolute;
    top: 0;
    right: 0;
    width: 1.537rem;
    text-align: center;
  }

  .WeChatAuthorizat-DynamicCode > div:first-child,
  .WeChatAuthorizat-code:first-child {
    margin-right: 2.66rem;
  }

  .WeChatAuthorizat-DynamicCode > div,
  .WeChatAuthorizat-code > div {
    height: 1.596rem;
    line-height: 1.596rem;
  }

  .WeChatAuthorizat-DynamicCode > div:nth-child(3) {
    position: absolute;
    right: 0.266rem;
    top: 0;
  }

  .WeChatAuthorizat-code > div:nth-child(3) {
    position: absolute;
    right: 0.266rem;
    top: 50%;
    margin-top: -0.399rem;
  }

  .WeChatAuthorizat-wrapper {
    padding: 1.064rem;
  }

  .WeChatAuthorizat-logo {
    width: 5.32rem;
    margin: 0 auto;
  }

  .WeChatAuthorizat-logo img {
    width: 100%;
  }

  .WeChatAuthorizat-item {
    margin-top: 3.537rem;
    border-radius: 0.133rem;
    background-color: #fff;
  }

  .sendCode {
    border-radius: 0.133rem;
    width: 2.394rem;
    height: 0.798rem;
    line-height: 0.798rem;
    background-color: #12a3ff;
    color: #fff;
    font-size: 0.372rem;
    text-align: center;
  }

  .WeChatAuthorizat-btn {
    font-size: 0.425rem;
    text-align: center;
    width: 100%;
    height: 1.197rem;
    line-height: 1.197rem;
    margin-top: 1.197rem;
    background-color: #ff7200;
    color: #fff;
    border-radius: 0.106rem;
  }
</style>
<script>
  import UserService from "@/service/UserService";
  import { AuthType } from "@/model/Base";
  export default {
    data() {
      return {
        judgeCode: true,
        pwdFlag: false,
        textCode: "system.TestGetCode",
        WeChatTabs: [
          {
            label: this.$root.$t("system_user_modules_authorizat_zhanghaobangding"),
            value: 0,
          },
          {
            label: this.$root.$t("system_user_modules_authorizat_shoujiyanzhengbangding"),
            value: 1,
          },
        ],
        WeChatType: 0,
      };
    },
    props: ["value", "checkImageUrl"],
    computed: {
      AuthTypeTypes() {
        return this.$store.getters.categorys.types.AuthType;
      },
      redirect() {
        return this.$route.query.redirect;
      },
    },
    methods: {
      ChaneWeChatType(value) {
        let __self = this;
        __self.WeChatType = value;
      },
      ReloadImage() {
        let __self = this;
        __self.$emit("ReloadImage");
      },
      // sendCode() {
      //   let __self = this
      //   __self.$emit('sendCode')

      // },
      sendCode() {
        let __self = this;
        if (__self.value.UserAct == "") {
          return this.$root.$toast(__self.$t("share.fail.Account"));
        }
        if (__self.value.ValidCode == "") {
          return this.$notify(__self.$t("share.fail.VerificationCode"));
        }
        if (!__self.judgeCode) {
          return;
        }
        __self.judgeCode = false;
        let $time = 60;

        function run() {
          __self.textCode = __self.$t("system.Sent") + "(" + --$time + ")";
          if ($time <= 0) {
            clearInterval(__self.setInterval);
            __self.textCode = "system.TestGetCode";
            __self.judgeCode = true;
          } else {
            __self.judgeCode = false;
          }
        }
        UserService.sendValidCode(__self.value).then(json => {
          if (json.isSucc) {
            __self.setInterval = setInterval(run, 1000);
            this.$root.$toast.success(json.message);
          }
          __self.judgeCode = true;
        });
      },
      login() {
        let __self = this;
        let data = {
          UserAct: __self.value.UserAct,
          IsRemember: __self.value.IsRemember,
          DeviceInfo: __self.value.DeviceInfo,
          ValidCode: __self.value.ValidCode,
        };
        if (__self.value.UserAct == "") {
          return this.$notify(__self.$t("share.fail.AccountEmpty"));
        }
        if (__self.WeChatType == 0) {
          if (__self.value.UserPwd == "") {
            return this.$notify(__self.$t("share.fail.PasswordEmpty"));
          }
          data.LoginMode = AuthType.AccountAuth;
          data.UserPwd = __self.value.UserPwd;
        } else {
          data.LoginMode = AuthType.DynamicAuth;
          data.UserPwd = __self.value.UserCode;
          if (__self.value.ValidCode == "") {
            return this.$notify(__self.$t("share.fail.VerificationCode"));
          }
          if (__self.value.UserCode == "") {
            return this.$notify(__self.$t("share.fail.DynamicCode"));
          }
        }
        __self.$emit("login", data);
      },
      ToReset() {
        let __self = this;
        __self.$router.push({
          path: "/reset",
        });
      },
      ToRegister() {
        let __self = this;
        __self.$router.push({
          path: "/businessRegister",
          query: {
            redirect: __self.redirect,
          },
        });
      },
    },
  };
</script>
